import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
import React, { Component } from 'react';
import Touchable from 'rmc-feedback';

var InputHandler = function (_Component) {
    _inherits(InputHandler, _Component);

    function InputHandler() {
        _classCallCheck(this, InputHandler);

        return _possibleConstructorReturn(this, (InputHandler.__proto__ || Object.getPrototypeOf(InputHandler)).apply(this, arguments));
    }

    _createClass(InputHandler, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                disabled = _a.disabled,
                onTouchStart = _a.onTouchStart,
                onTouchEnd = _a.onTouchEnd,
                otherProps = __rest(_a, ["prefixCls", "disabled", "onTouchStart", "onTouchEnd"]);
            return React.createElement(
                Touchable,
                { disabled: disabled, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd, activeClassName: prefixCls + '-handler-active' },
                React.createElement('span', otherProps)
            );
        }
    }]);

    return InputHandler;
}(Component);

export default InputHandler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-input-number/es/InputHandler.js
// module id = 444
// module chunks = 0